export enum SearchType {
    Simple = 1,
    SingleFilter = 2,
    FilterOnly = 3,
    Advanced = 4,
    NotesAdvanced = 5,
    CaseHistoryAdvanced = 6
}
